import tivitLogo from './tivitLogo.svg';
import focusLogo from './focusLogo.svg';

import focusAvatar from './focusAvatar.svg';
import tivitAvatar from './tivitAvatar.svg';


namespace tivit {
    export const companyName = 'TiViT';
    export const companyTitle = `${companyName} - Fastest growing casino`;
    export const companyDescription = `Risk, play and earn real money in ${companyName} casino, register on ${process.env.REACT_APP_SITE_URL_HOST} and top up account in any currency!`;
    export const affilateNet = 'tivit.partners';
    export const supportTelegram = 'https://t.me/tivit_support';
    export const supportEmail = 'support@tivit.bet';

    export const companyLogo = tivitLogo;
    export const avatar = tivitAvatar;

    export const primarySuperLight = '#7A7E8C';
    export const primarySemiSuperLight = '#383C51';
    export const primaryLight = '#171b33';
    export const primaryDark = '#0a0d1e';

    export const accent = '#FFA021';
    export const primaryActive = '#ffc83b';

    export const primaryNormal: string = accent;
    export const primaryHover: string = accent;
    export const primaryFocus: string = accent;

    export const depositButtonColor: string = accent;
}


export namespace focus {
    export const companyName = 'FocusBet';
    export const companyTitle = `${companyName} - iGaming platform of big cash prizes`;
    export const companyDescription = `Risk, play and earn real money on ${companyName} iGaming platform, register on ${process.env.REACT_APP_SITE_URL_HOST} and top up account in any currency!`;
    export const affilateNet = '4cus-partner.com';
    export const supportTelegram = 'https://t.me/focussupport';
    export const supportEmail = 'support@focusbet.io';

    export const companyLogo = focusLogo;
    export const avatar = focusAvatar;

    export const primarySuperLight = '#323d4c';
    export const primarySemiSuperLight = '#212C39';
    export const primaryLight = '#17212B';
    export const primaryDark = '#0E1621';

    export const accent = '#2988f6';
    export const primaryActive = '#438AEE';

    export const primaryNormal: string = accent;
    export const primaryHover: string = accent;
    export const primaryFocus: string = accent;

    export const depositButtonColor = 'rgb(52, 199, 89)';
}


export const brand = process.env.REACT_APP_COMPANY === 'focus' ? focus : tivit
